import { useMutation, useQueryClient } from "@tanstack/react-query";
import { addFavoriteApi, removeFavoriteApi } from "./api/products";

export const useFavorites = (token) => {
  const queryClient = useQueryClient();

  const addFavoriteMutation = useMutation({
    mutationFn: async (productId) => addFavoriteApi(productId, token),
    onSuccess: () => {
      queryClient.invalidateQueries(["userFavorites"]);
    },
  });

  const removeFavoriteMutation = useMutation({
    mutationFn: async (productId) => removeFavoriteApi(productId, token),
    onSuccess: () => {
      queryClient.invalidateQueries(["userFavorites"]);
    },
  });

  return { addFavoriteMutation, removeFavoriteMutation };
};
